<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">404</h1>
          <h4 class="pt-3">Oops!</h4>
          <p class="text-muted">The page you are looking for is unavailable. Click here to go back to <CLink to="/">{{ baseURL }}</CLink></p>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: 'Page404',
  computed: {
    baseURL () {
      return window.location.origin.split('//')[1]
    }
  }
}
</script>
